import script from "./ProductSpecificationsDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductSpecificationsDetails.vue?vue&type=script&setup=true&lang=ts"

import "./ProductSpecificationsDetails.vue?vue&type=style&index=0&id=754b8c5a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-754b8c5a"]])

export default __exports__